module.exports = __webpack_public_path__ + "static/dekorate-ddfaf65425ba5e4c2b51aa202110cdd7.png";